import { useState, useEffect } from "react";
import axios from "axios";

function AddTechnician({ onClose }) {

const [username,setUsername]=useState("");
const [email,setEmail]=useState("");
const [password,setPassword]=useState("");

const [employeeCode,setEmployeeCode]=useState("");
const [mobile,setMobile]=useState("");
const [address,setAddress]=useState("");

const [departmentId,setDepartmentId]=useState("");
const [designationId,setDesignationId]=useState("");

const [skills,setSkills]=useState("");
const [joiningDate,setJoiningDate]=useState("");

const [experienceYears,setExperienceYears]=useState("");
const [status,setStatus]=useState("Active");

const [departments,setDepartments]=useState([]);
const [designations,setDesignations]=useState([]);

useEffect(()=>{

loadDepartments();
loadDesignations();

},[]);

const loadDepartments=async()=>{

try{

const token=localStorage.getItem("token");

const response=await axios.get(

"https://saleupcall.com/api/Department/get-departments.php",

{
headers:{
Authorization:`Bearer ${token}`
}
}

);

if(response.data.status){

setDepartments(response.data.data);

}

}
catch(error){

console.log(error);

}

};

const loadDesignations=async()=>{

try{

const token=localStorage.getItem("token");

const response=await axios.get(

"https://saleupcall.com/api/Designation/get-designations.php",

{
headers:{
Authorization:`Bearer ${token}`
}
}

);

if(response.data.status){

setDesignations(response.data.data);

}

}
catch(error){

console.log(error);

}

};

const saveTechnician=async(e)=>{

e.preventDefault();

try{

const token=localStorage.getItem("token");

const response=await axios.post(

"https://saleupcall.com/api/Technician/add-technician.php",

{

username,
email,
password,

employee_code:employeeCode,
mobile,
address,

department_id:departmentId,
designation_id:designationId,

skills,
joining_date:joiningDate,
experience_years:experienceYears,
status

},

{
headers:{
Authorization:`Bearer ${token}`
}
}

);

if(response.data.status){

alert("Technician Added");

setUsername("");
setEmail("");
setPassword("");

setEmployeeCode("");
setMobile("");
setAddress("");

setDepartmentId("");
setDesignationId("");

setSkills("");
setJoiningDate("");

setExperienceYears("");
setStatus("Active");

if(onClose){

onClose();

}

}
else{

alert(response.data.message);

}

}
catch(error){

console.log(error);

}

};

return(

<form onSubmit={saveTechnician}>

<h5 className="mb-3">

Login Details

</h5>

<div className="row">

<div className="col-md-4 mb-2">

<input type="text" className="form-control form-control-sm" placeholder="Username" value={username} onChange={(e)=>setUsername(e.target.value)} />

</div>

<div className="col-md-4 mb-2">

<input type="email" className="form-control form-control-sm" placeholder="Email" value={email} onChange={(e)=>setEmail(e.target.value)} />

</div>

<div className="col-md-4 mb-2">

<input type="password" className="form-control form-control-sm" placeholder="Password" value={password} onChange={(e)=>setPassword(e.target.value)} />

</div>

</div>

<hr/>

<h5 className="mb-3">

Technician Details

</h5>

<div className="row">

<div className="col-md-6 mb-2">

<input type="text" className="form-control form-control-sm" placeholder="Employee Code" value={employeeCode} onChange={(e)=>setEmployeeCode(e.target.value)} />

</div>

<div className="col-md-6 mb-2">

<input type="text" className="form-control form-control-sm" placeholder="Mobile" value={mobile} onChange={(e)=>setMobile(e.target.value)} />

</div>

<div className="col-md-6 mb-2">

<select className="form-select form-select-sm" value={departmentId} onChange={(e)=>setDepartmentId(e.target.value)}>

<option value="">

Select Department

</option>

{
departments.map((item)=>(

<option key={item.id} value={item.id}>

{item.department_name}

</option>

))
}

</select>

</div>

<div className="col-md-6 mb-2">

<select className="form-select form-select-sm" value={designationId} onChange={(e)=>setDesignationId(e.target.value)}>

<option value="">

Select Designation

</option>

{
designations.map((item)=>(

<option key={item.id} value={item.id}>

{item.designation_name}

</option>

))
}

</select>

</div>

<div className="col-md-6 mb-2">

<input type="text" className="form-control form-control-sm" placeholder="Skills" value={skills} onChange={(e)=>setSkills(e.target.value)} />

</div>

<div className="col-md-6 mb-2">

<input type="date" className="form-control form-control-sm" value={joiningDate} onChange={(e)=>setJoiningDate(e.target.value)} />

</div>

<div className="col-md-6 mb-2">

<input type="number" className="form-control form-control-sm" placeholder="Experience (Years)" value={experienceYears} onChange={(e)=>setExperienceYears(e.target.value)} />

</div>

<div className="col-md-6 mb-2">

<select className="form-select form-select-sm" value={status} onChange={(e)=>setStatus(e.target.value)}>

<option value="Active">Active</option>

<option value="Inactive">Inactive</option>

</select>

</div>

<div className="col-md-12 mb-2">

<textarea className="form-control form-control-sm" rows="2" placeholder="Address" value={address} onChange={(e)=>setAddress(e.target.value)} />

</div>

</div>

<div className="text-end mt-1">

<button type="submit" className="btn btn-primary btn-sm">

<i className="bi bi-check-lg me-1"></i>

Save Technician

</button>

</div>

</form>

);

}

export default AddTechnician;